<template>
    <v-menu offset-y :close-on-content-click="false" v-model="cartOpen">
        <!-- Cart Button -->
        <template v-slot:activator="{ on: menu, attrs }">
            <v-btn text small v-on="menu" v-bind="attrs" :ripple="false">
                <v-badge :content="itemsAmount" :value="itemsAmount">
                    <v-icon left small>mdi-cart</v-icon>Cart
                </v-badge>
            </v-btn>

            <!-- <v-btn
                text
                v-bind="attrs"
                v-on="menu"
                class="px-1 mr-1"
                style="min-width: 48px"
            >
                <v-badge :content="itemsAmount" :value="itemsAmount">
                    <v-icon>mdi-cart</v-icon>
                </v-badge>
            </v-btn> -->
        </template>

        <v-list dense min-width="240px">
            <!-- Sumery Info -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-medium text-center"
                        >My Cart
                        {{
                            itemsAmount == 0 ? `( empty )` : ``
                        }}</v-list-item-title
                    >
                </v-list-item-content>
            </v-list-item>

            <!-- Items List -->
            <v-list-item v-for="(item, id) in cartItems" :key="id">
                <!-- Items Info -->
                <v-list-item-title>
                    <v-row class="ml-0 mr-1 font-weight-regular">
                        <router-link
                            :to="`/${item.type}/p/${id}`"
                            class="text-decoration-none black--text mr-2"
                            >{{ item.title }} ({{ item.quantity }})</router-link
                        >
                        <v-spacer></v-spacer>
                        {{ item.price.toLocaleString() }} THB
                    </v-row>
                </v-list-item-title>

                <!-- Remove Button -->
                <v-list-item-action class="ml-2 my-0">
                    <v-btn small icon text @click="removeItem(id)">
                        <v-icon color="red lighten-1">remove</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>

            <!-- Process -->
            <v-list-item v-if="itemsAmount != 0">
                <v-list-item-title>
                    <v-btn
                        to="/checkout"
                        @click="cartOpen = false"
                        small
                        block
                        depressed
                        color="red"
                        dark
                        :ripple="false"
                        >Buy</v-btn
                    >
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            cartOpen: false,
        };
    },
    methods: {
        removeItem(id) {
            this.$store.dispatch({
                type: "EditItem",
                removeItem: id,
            });
        },
    },
    computed: {
        ...mapState(["cartItems"]),
        itemsAmount() {
            if (Object.keys(this.cartItems).length) {
                return Object.values(this.cartItems).reduce(
                    (t, { quantity }) => t + quantity,
                    0
                );
            }
            return 0;
        },
    },
};
</script>

<style>
</style>